import { render, staticRenderFns } from "./cc-capsule.vue?vue&type=template&id=22b684ae&"
import script from "./cc-capsule.vue?vue&type=script&lang=ts&"
export * from "./cc-capsule.vue?vue&type=script&lang=ts&"
import style0 from "./cc-capsule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports